import * as React from "react";
import {Checkbox, Col, Form, Icon, Input, Modal, Row, Select} from 'antd';
import {withTranslation, WithTranslation} from 'react-i18next';
import {FormComponentProps} from "antd/lib/form";
import {EmployeeItem, EmployeeStore} from "src/stores/employees-store";
import {clone, nameof} from 'src/core/utils/object';
import autobind from 'autobind-decorator';
import {IdentityProps, withIdentity} from 'src/core/services/authentication';
import {connect} from "redux-scaffolding-ts";


import {notificationService, withNotification} from '../../consumer/notificationContent';

let FormItem = Form.Item;


interface NotificationViewProps extends IdentityProps {
    forceShowModal: number;
}

interface NotificationViewState {
    isModalVisible: boolean
    employeeItem: EmployeeItem | undefined
    selectedTeamReport: boolean,
    selectedEmployeeReminder: boolean
}

@connect(["employee", EmployeeStore])
class NotificationView extends React.Component<NotificationViewProps & WithTranslation & FormComponentProps, NotificationViewState> {
   

    constructor(props: NotificationViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.state = {
            isModalVisible: false,
            employeeItem: undefined,
            selectedEmployeeReminder: false,
            selectedTeamReport: false
        }
    }

    @autobind
    private async load() {
        var company = notificationService.ActiveCompany
        if (!company) return undefined;
        var employeeId = notificationService.Employee;
        this.employeesStore.changeUrl(company ? company : "");
        var employee = await this.employeesStore.getById(employeeId ? employeeId.toString() : "");
        this.setState({ employeeItem: employee, selectedEmployeeReminder: employee!.timesheetReminder > 0, selectedTeamReport: employee!.teamReport > 0 })
        return employee
    }

    @autobind
    private teamReportOnchange(e: any) {
        this.setState({ selectedTeamReport: !this.state.selectedTeamReport },
            () => { this.state.selectedTeamReport ? this.props.form.setFieldsValue({ 'teamReport': 1, }) : this.props.form.setFieldsValue({ 'teamReport': false, }) })

    }

    @autobind
    private employeeReminderOnchange(e: any) {
        this.setState({ selectedEmployeeReminder: !this.state.selectedEmployeeReminder },
            () => { this.state.selectedEmployeeReminder ? this.props.form.setFieldsValue({ 'timesheetReminder': 1, }) : this.props.form.setFieldsValue({ 'timesheetReminder': false, }) })
    }

    private get employeesStore() {
        return (this.props as any).employee as EmployeeStore;
    }

    @autobind
    private handleUpdateItem(values: any) {
        var obj = clone(this.employeesStore.state.item) as EmployeeItem;
        obj.function = this.props.form.getFieldValue("function");
        obj.timesheetReminder = this.props.form.getFieldValue("timesheetReminder");
        obj.timesheetStatusNotificationEmployee = this.props.form.getFieldValue("timesheetStatusNotificationEmployee");
        obj.timesheetStatusNotificationManager = this.props.form.getFieldValue("timesheetStatusNotificationManager");
        obj.teamReport = this.props.form.getFieldValue("teamReport");
        this.setState({ isModalVisible: false })
        return new Promise((resolve, reject) => {
            this.employeesStore.updateNotifications(Object.assign(clone(this.employeesStore.state.item), obj)).then(result => {
                if (result.isSuccess) {
                    resolve()
                } else {
                    reject()
                }
            })
        })
    }

 

    componentWillUpdate(nextProps: NotificationViewProps) {
        if (nextProps.forceShowModal != this.props.forceShowModal) {
            this.setState({ isModalVisible: true})
            this.load();
        }
    }
  

    public render() {
        const { t } = this.props
        const { Option } = Select;
        const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form
        if (!this.state.employeeItem) return <div/>

        return <Modal title={t("Notifications")} visible={this.state.isModalVisible} onOk={this.handleUpdateItem} onCancel={() => this.setState({ isModalVisible: false })}>
            <Form id="modaForm">
            <Row gutter={24} align='middle' justify='center' >
                <Col span={8}>
                    <h5 style={{ fontWeight: 'bold', marginTop: '7px' }}>{t("Identification")}</h5>
                </Col>
            </Row>

            <Row gutter={24} align='middle' justify='center' >
                <Col span={12} >
                    <FormItem label={t("Title")}>
                        {this.props.form.getFieldDecorator(nameof<EmployeeItem>('title'), {
                            initialValue: this.employeesStore.state.item?.title
                        })(
                            <Input disabled placeholder={t('Title')} type="text" />
                        )}
                        </FormItem>
                        <Row gutter={24} >
                            <Col span={24} >
                                <FormItem label={t("Language")}>
                                    {this.props.form.getFieldDecorator(nameof<EmployeeItem>('language'), {
                                        rules: [], initialValue: this.employeesStore.state.item?.language,
                                    })(
                                        <Select style={{ width: "100" }} >
                                            <Option value={"en"} key={"en"}> {t("English")} </Option>
                                            <Option value={"fr"} key={"fr"}> {t("French")} </Option>
                                            <Option value={"es"} key={"sp"}> {t("Spanish")} </Option>
                                            <Option value={"pt"} key={"pt"}> {t("Portuguese")} </Option>
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    <Row gutter={24}>
                        <Col span={24} >
                                <FormItem label={t("Function")}>
                                {this.props.form.getFieldDecorator(nameof<EmployeeItem>('function'), {
                                    initialValue: this.employeesStore.state.item?.function,
                                    })(
                                        <Input placeholder={t('Function')} type="text" />
                                    )}
                                </FormItem>
                        </Col>
                    </Row>
                </Col>  
            </Row>

            <Row gutter={24}>

                <Col span={24}>
                    <Row gutter={24} type={'flex'} align='middle'>
                        <Col span={14}>
                            <Checkbox checked={this.state.selectedEmployeeReminder} defaultChecked={this.state.selectedEmployeeReminder} onChange={this.employeeReminderOnchange}><span>{t("Send reminders for timesheet entry")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                        </Col>
                        <Col span={10}>
                            <FormItem>
                                {this.props.form.getFieldDecorator(nameof<EmployeeItem>('timesheetReminder'), {
                                    rules: [], initialValue: this.employeesStore.state.item?.timesheetReminder ? (this.state.selectedEmployeeReminder ? this.employeesStore.state.item?.timesheetReminder : false) : (this.state.selectedEmployeeReminder ? 1 : false)
                                })(
                                    <Select disabled={!this.state.selectedEmployeeReminder} style={{ width: "100" }} >
                                        <Option value={1} key={1}> {t("Weekly")} </Option>
                                        <Option value={2} key={2}> {t("Fortnightly")} </Option>
                                        <Option value={3} key={3}> {t("Monthly")} </Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={24} type={'flex'} align='middle'>
                        <Col span={14}>
                            <Checkbox checked={this.state.selectedTeamReport} defaultChecked={this.state.selectedTeamReport} onChange={this.teamReportOnchange}><span>{t("Send team report")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                        </Col>
                        <Col span={10}>
                            <FormItem>
                                {this.props.form.getFieldDecorator(nameof<EmployeeItem>('teamReport'), {
                                    rules: [], initialValue: this.employeesStore.state.item?.teamReport ? (this.state.selectedTeamReport ? this.employeesStore.state.item?.teamReport : false) : (this.state.selectedTeamReport ? 1 : false)
                                })(
                                    <Select disabled={!this.state.selectedTeamReport} style={{ width: "100" }} >
                                        <Option value={2} key={2}> {t("Quickly")} </Option>
                                        <Option value={1} key={1}> {t("Monthly")} </Option>
                                        <Option value={3} key={3}> {t("Quarterly")} </Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={24}>
                                <FormItem>
                                {this.props.form.getFieldDecorator(nameof<EmployeeItem>('timesheetStatusNotificationEmployee'), {
                                    rules: [], initialValue: this.employeesStore.state.item?.timesheetStatusNotificationEmployee, valuePropName: 'checked'
                                    })(
                                        <Checkbox><span>{t("Send an email when approving / rejecting timesheet")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                    )}
                                </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                       <Col span={24}>
                                <FormItem>
                                {this.props.form.getFieldDecorator(nameof<EmployeeItem>('timesheetStatusNotificationManager'), {
                                    rules: [], initialValue: this.employeesStore.state.item?.timesheetStatusNotificationManager, valuePropName: 'checked'
                                    })(
                                        <Checkbox><span>{t("Send e-mail when timesheet has been published")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                    )}
                                </FormItem>
                        </Col>
                    </Row>
                </Col>
                </Row>

                
                </Form>
        </Modal>
    }
}
export default withTranslation()(Form.create({})(withIdentity(withNotification(NotificationView as any) as any)) as any) as any as React.ComponentClass<NotificationViewProps>;